import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { JackpotCounterComponent } from './jackpot-counter';
import { MobileModule } from '../mobile/mobile.module';
import { JackpotCounterService } from 'src/app/services/jackpot-counter/jackpot-notification-counter';
import { PipesModule } from 'src/app/pipes/pipes.module';
import { JackpotserviceService } from 'src/app/services/jackpot/jackpotservice.service';




@NgModule({
  declarations: [
    JackpotCounterComponent
  ],
  providers:[
    JackpotCounterService,
    JackpotserviceService
  ],
  imports: [
    CommonModule,
    PipesModule,
    MobileModule,
  ],
  exports:[
    JackpotCounterComponent
  ]
})
export class JackpotCounterModule { }
